<template>

  <div id="page-user-edit" class="vx-card p-6">

    <vx-card card-border class="mb-4" title="Cuenta del usuario" title-color="dark" collapseAction>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Empresa *</span>
          </div>
          <div>
            <v-select class="w-full" 
              v-model="usuario.empresa" 
              :options="empresas" 
              :selectable="option => option.activa === true"
              label="nombre"
              :reduce="id => `/api/empresas/${id.id}`" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          &nbsp;
        </div>
      </div>
      <vs-divider color="dark">Login</vs-divider>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Username *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="USERNAME" v-model="usuario.username" 
              v-validate="'required|alpha_num'" name="username" />
            <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Contraseña *</span>
          </div>
          <div>
            <vs-input type="password" class="w-full" data-vv-as="CONTRASEÑA" v-model="usuario.password" 
              v-validate="'required'" name="password" />
            <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
        </div>
      </div>
      <vs-divider color="dark">Datos del usuario</vs-divider>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">DNI *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="DNI" v-model="usuario.dni" v-validate="'required|alpha_num|checkDNI'" 
              name="dni" />
            <span class="text-danger text-sm"  v-show="errors.has('dni')">{{ errors.first('dni') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          &nbsp;
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Nombre *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-model="usuario.nombre" v-validate="'required'" name="nombre" />
            <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Apellidos *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="APELLIDOS" v-model="usuario.apellidos" v-validate="'required'" 
              name="apellidos" />
            <span class="text-danger text-sm"  v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">E-mail *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="EMAIL" v-model="usuario.email" type="email" 
              v-validate="'required|email'" name="email" />
            <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span class="campoObligatorio">Teléfono de contacto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
              name="telefono" v-model="usuario.telefono"/>
            <span class="text-danger text-sm"  v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
          </div>
        </div>
      </div>
      <vs-divider color="dark">Permisos</vs-divider>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <span>Usuario inactivo/activo</span>
          </div>
          <div class="vx-col w-full mb-6">
            <vs-switch vs-type="success" v-model="usuario.activo"/>
          </div>
          <div v-if="usuario.roles.includes('ROLE_COMERCIAL')" class="vx-col w-full mb-3">
            <span>Supervisor</span>
          </div>
          <div v-if="usuario.roles.includes('ROLE_COMERCIAL')" class="vx-col w-full">
            <v-select class="w-full" 
              v-model="usuario.supervisor" 
              :options="supervisores" 
              :selectable="option => option.activo === true"
              label="nombre"
              :reduce="id => id.id" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vx-card no-shadow card-border>
            <div>
              <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="leading-none">Permisos especiales</span>
              </div>
              <vs-divider />
            </div>
            <div>
              <table class="w-full">
                <tr>
                  <td><vs-switch vs-type="success" v-model="usuario.roles" vs-value="ROLE_ADMIN">ROLE_ADMIN</vs-switch></td>
                  <td class="text-base text-left px-3 py-2">ADMINISTRADOR</td>
                </tr>
                <tr>
                  <td><vs-switch vs-type="success" v-model="usuario.roles" vs-value="ROLE_SUPERVISOR">ROLE_SUPERVISOR</vs-switch></td>
                  <td class="text-base text-left px-3 py-2">SUPERVISOR</td>
                </tr>
                <tr>
                  <td><vs-switch vs-type="success" v-model="usuario.roles" vs-value="ROLE_COMERCIAL">ROLE_COMERCIAL</vs-switch></td>
                  <td class="text-base text-left px-3 py-2">COMERCIAL</td>
                </tr>
              </table>
            </div>
          </vx-card>
        </div>
      </div>
      
      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar_usuario" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>

</template>


<script>
import empresasStore from '@/store/configuracion/empresas/index.js'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      empresas: [],
      supervisores: [],
      usuario: {
        apellidos: '',
        dni: '',
        email: '',
        empresa: null,
        nombre: '',
        password: '',
        roles: [],
        username: '',
        activo: null,
        supervisor: null
      },
      activeTab: 0
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any()
        || this.usuario.empresa === undefined || this.usuario.empresa === null
        || this.usuario.username === undefined || this.usuario.username === null 
        || this.usuario.password === undefined || this.usuario.password === null  
        || this.usuario.dni === undefined || this.usuario.dni === null 
        || this.usuario.nombre === undefined || this.usuario.nombre === null
        || this.usuario.apellidos === undefined || this.usuario.apellidos === null
        || this.usuario.email === undefined || this.usuario.email === null  
        || this.usuario.telefono === undefined || this.usuario.telefono === null) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    guardar_usuario () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      // No caso de que non sexa un comercial (si se desmarca ROLE_COMERCIAL) asegurámonos de que o supervisor sexa null
      if (!this.usuario.roles.includes('ROLE_COMERCIAL')) { this.usuario.supervisor = null }  
      this.$store.dispatch('userManagement/updateUser', this.usuario)
        .then(()   => { 
          this.$router.push({name:'usuarios'})
          this.showUpdateSuccess() 
        })
        .catch(err => { this.showUpdateError(err) })
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Usuario modificado',
        text: 'El usuario ha sido modificado correctamente'
      })
    },
    showUpdateError () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'El usuario no ha podido ser modificado.'
      })
    },
    reset_data () {
      this.$router.push({name:'usuarios'})
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const id = this.$route.params.userId
    await this.$store.dispatch('userManagement/fetchUser', id)
      .then(res => { 
        this.usuario = res.data
        this.usuario.empresa = `/api/empresas/${ res.data.empresa.id }`
        this.usuario.supervisor = res.data.supervisor
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          this.user_not_found = true
          return
        }
        console.error(err) 
      })

    await this.$store.dispatch('empresasStore/getEmpresas')
      .then(() => {
        // Gardamos o id da empresa que ten asociada o usuario
        const idEmpresa = this.usuario.empresa.split('/')
        // Recorremos as empresas e se están activas ou se teñen o mesmo id que o que ten asociado o usuario engadímolas ao combo
        this.$store.state.empresasStore.empresas.forEach(element => {
          if (element.activa || element.id == idEmpresa[3]) this.empresas.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })

    await this.$store.dispatch('userManagement/getSupervisores')
      .then(() => {
        // Gardamos o id da empresa que ten asociada o usuario
        const idSupervisor = this.usuario.supervisor
        // Recorremos as empresas e se están activas ou se teñen o mesmo id que o que ten asociado o usuario engadímolas ao combo
        this.$store.state.userManagement.supervisores.forEach(element => {
          if (element.activo || element.id == idSupervisor) {
            element.nombre = `${element.nombre} ${element.apellidos}`
            this.supervisores.push(element)
          }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>